<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>

         <v-card class="cpd-list-card">
            <v-toolbar flat color="white">
               <v-toolbar-title>CPD Events & Programs</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="success" dark class="mr-2" @click="openAddDialog">
                  <v-icon left small>mdi-plus</v-icon>
                  Add New Programme
               </v-btn>
               <v-btn color="primary" dark class="mr-2" href="/admin/cpd">Member CPD</v-btn>
               <v-btn color="primary" dark @click="loadItems" :loading="loading">Refresh</v-btn>
            </v-toolbar>

            <v-tabs v-model="tab" background-color="primary" dark>
               <v-tab>Approved</v-tab>
               <v-tab>Pending Review</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
               <v-tab-item>
                  <v-data-table
                     :headers="headers"
                     :items="approvedItems"
                     :loading="loading"
                     class="border cpd-table"
                     no-data-text="No data available"
                  >
                     <template v-slot:item.isapproved="{ item }">
                        <v-chip x-small color="green darken-1" dark>Approved</v-chip>
                     </template>
                     <template v-slot:item.actions="{ item }">
                        <v-btn x-small color="indigo" dark class="mr-1" @click="openEditDialog(item)">Edit</v-btn>
                        <v-btn x-small color="error" dark @click="deleteItem(item)">Delete</v-btn>
                     </template>
                  </v-data-table>
               </v-tab-item>
               <v-tab-item>
                  <v-data-table
                     :headers="headers"
                     :items="pendingItems"
                     :loading="loading"
                     class="border cpd-table"
                     no-data-text="No data available"
                  >
                     <template v-slot:item.isapproved="{ item }">
                        <v-chip x-small color="orange darken-2" dark>Pending</v-chip>
                     </template>
                     <template v-slot:item.actions="{ item }">
                        <v-btn x-small color="success" dark class="mr-1" @click="approveItem(item)">Approve</v-btn>
                        <v-btn x-small color="indigo" dark class="mr-1" @click="openEditDialog(item)">Edit</v-btn>
                        <v-btn x-small color="error" dark @click="deleteItem(item)">Reject</v-btn>
                     </template>
                  </v-data-table>
               </v-tab-item>
            </v-tabs-items>
         </v-card>

         <v-dialog v-model="dialog" max-width="650" persistent>
            <v-card>
               <v-card-title>
                  {{ editMode ? 'Edit Programme' : 'Add New Programme' }}
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
               </v-card-title>
               <v-card-text>
                  <v-row dense>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formData.epcode" label="EP Code *" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-select
                           v-model="formData.epcatid"
                           :items="categories"
                           item-text="category"
                           item-value="id"
                           label="Category *"
                           outlined dense
                        ></v-select>
                     </v-col>
                     <v-col cols="12">
                        <v-text-field v-model="formData.epname" label="Programme Name *" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formData.eporg" label="Organizer" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formData.epcontactno" label="Contact No" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-text-field v-model="formData.eppoints" label="Points *" type="number" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-text-field v-model="formData.epyear" label="EP Year *" type="number" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-text-field v-model="formData.epduration" label="Duration (hrs)" type="number" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formData.epdate" label="EP Date" type="date" outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-checkbox v-model="formData.isapproved" label="Approved" dense class="mt-2"></v-checkbox>
                     </v-col>
                  </v-row>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialog = false">Cancel</v-btn>
                  <v-btn color="success" dark :loading="saving" @click="saveProgram">Save</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-snackbar v-model="snackbar" :color="snackbarColor">{{ snackbarText }}</v-snackbar>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOACpdEventProgs',
   components: { DashboardLayout, BaseBreadcrumb },
   data() {
      return {
         page: { title: 'CPD Management' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'CPD Management', disabled: false, to: '/admin/cpd' },
            { text: 'CPD Events & Programs', disabled: true },
         ],
         tab: 0,
         loading: false,
         saving: false,
         approvedItems: [],
         pendingItems: [],
         categories: [],
         dialog: false,
         editMode: false,
         formData: this.emptyForm(),
         headers: [
            { text: 'EP Year', value: 'epyear' },
            { text: 'EP Code', value: 'epcode' },
            { text: 'EP Name', value: 'epname' },
            { text: 'Category', value: 'category' },
            { text: 'Points', value: 'eppoints' },
            { text: 'EP Date', value: 'epdate' },
            { text: 'Organizer', value: 'eporg' },
            { text: 'Status', value: 'isapproved', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false },
         ],
         snackbar: false,
         snackbarColor: 'info',
         snackbarText: '',
      }
   },
   mounted() {
      this.loadItems()
      this.loadCategories()
   },
   methods: {
      emptyForm() {
         return {
            id: null,
            epcode: '',
            epcatid: null,
            epname: '',
            eporg: '',
            epcontactno: '',
            eppoints: 0,
            epyear: new Date().getFullYear(),
            epduration: 1,
            epdate: '',
            isapproved: false,
         }
      },
      loadItems() {
         this.loading = true
         Promise.all([
            axios.get('/admin/cpd-evtprogs/list'),
            axios.get('/admin/cpd-evtprogs/list-unapproved'),
         ]).then(([approved, pending]) => {
            this.approvedItems = this.responseItems(approved)
            this.pendingItems = this.responseItems(pending)
         }).finally(() => {
            this.loading = false
         })
      },
      loadCategories() {
         axios.get('/admin/cpd-evtprg-cat/ddllist').then(res => {
            this.categories = this.responseItems(res)
         })
      },
      responseItems(resp) {
         return resp.data && resp.data.status === 'OK' ? (resp.data.data || []) : []
      },
      notify(success, text) {
         this.snackbar = true
         this.snackbarColor = success ? 'success' : 'error'
         this.snackbarText = text
      },
      errorText(resp) {
         if (resp && resp.error) return resp.error
         if (resp && resp.data && resp.data.error) return resp.data.error
         return 'Something went wrong'
      },
      openAddDialog() {
         this.editMode = false
         this.formData = this.emptyForm()
         this.dialog = true
      },
      openEditDialog(item) {
         this.editMode = true
         this.formData = {
            id: item.id,
            epcode: item.epcode,
            epcatid: item.epcatid,
            epname: item.epname,
            eporg: item.eporg,
            epcontactno: item.epcontactno,
            eppoints: item.eppoints,
            epyear: item.epyear,
            epduration: item.epduration,
            epdate: item.epdate ? item.epdate.substring(0, 10) : '',
            isapproved: !!item.isapproved,
         }
         this.dialog = true
      },
      saveProgram() {
         if (!this.formData.epcode || !this.formData.epcatid || !this.formData.epname || !this.formData.eppoints) {
            this.notify(false, 'Please fill in EP Code, Category, Name and Points')
            return
         }
         this.saving = true
         const payload = {
            ...this.formData,
            isapproved: this.formData.isapproved ? 'true' : 'false',
            epsubmitdate: new Date().toISOString().substring(0, 10),
         }
         const url = this.editMode ? '/admin/cpd-evtprogs/update' : '/admin/cpd-evtprogs/add'
         axios.post(url, payload).then(res => {
            if (res.data && res.data.status === 'OK') {
               this.notify(true, res.data.message || 'Saved successfully')
               this.dialog = false
               this.loadItems()
            } else {
               this.notify(false, this.errorText(res.data))
            }
         }).catch(err => {
            this.notify(false, this.errorText(err))
         }).finally(() => {
            this.saving = false
         })
      },
      approveItem(item) {
         if (!confirm(`Approve programme "${item.epname}"?`)) return
         const payload = {
            id: item.id,
            epcode: item.epcode,
            epcatid: item.epcatid,
            epname: item.epname,
            eporg: item.eporg,
            epcontactno: item.epcontactno,
            eppoints: item.eppoints,
            epyear: item.epyear,
            epduration: item.epduration,
            epdate: item.epdate,
            isapproved: 'true',
         }
         axios.post('/admin/cpd-evtprogs/update', payload).then(res => {
            if (res.data && res.data.status === 'OK') {
               this.notify(true, 'Programme approved')
               this.loadItems()
            } else {
               this.notify(false, this.errorText(res.data))
            }
         }).catch(err => {
            this.notify(false, this.errorText(err))
         })
      },
      deleteItem(item) {
         if (!confirm(`Delete/Reject programme "${item.epname}"? This cannot be undone.`)) return
         axios.post('/admin/cpd-evtprogs/delete', { id: item.id }).then(res => {
            if (res.data && res.data.status === 'OK') {
               this.notify(true, 'Programme removed')
               this.loadItems()
            } else {
               this.notify(false, this.errorText(res.data))
            }
         }).catch(err => {
            this.notify(false, this.errorText(err))
         })
      },
   },
}
</script>

<style scoped>
.cpd-list-card ::v-deep .v-toolbar__title {
   font-size: 18px;
   font-weight: 500;
}

.cpd-table ::v-deep .v-data-table-header th {
   font-weight: 600;
}

.cpd-table ::v-deep tbody td {
   font-size: 12px;
   line-height: 1.35;
}
</style>